import React from 'react';

import RadioGroup from '@magoosh/lib/formik_inputs/field_radio_group';
import { formatPrice } from 'utilities/money';

import { BillingCycle, SubscriptionPlan } from '@payments/types';
import * as utils from '@payments/utils';

interface Props {
  billingCycle: BillingCycle;
  onChange: (billingCycle: BillingCycle) => void;
  subscriptionPlan: SubscriptionPlan;
  totalExcludingTax: number;
}

export const InstallmentsFormGroup: React.FC<Props> = ({
  billingCycle,
  onChange,
  subscriptionPlan,
  totalExcludingTax
}) => {
  const formattedInstallmentsDates = utils.calculateInstallmentsDates(
    subscriptionPlan.installmentInterval,
    subscriptionPlan.installmentIntervalCount
  );

  return (
    <div className="form-group">
      <fieldset className="inputs">
        <legend className="u-margin-B-n">
          <span>Payment</span>
        </legend>
        <div className="d-flex justify-content-between">
          <RadioGroup
            // Radios group in the DOM by name, so this is kept apart from the payment methods
            // group's "paymentMethod". The parent copies our selection onto billingCycle.
            name="paymentStyle"
            optionsArray={[
              {
                label: `Pay full ${formatPrice(totalExcludingTax)} today`,
                value: BillingCycle.ONE_TIME
              },
              {
                label: 'Pay in installments',
                value: BillingCycle.INSTALLMENTS,
                children: (
                  <div>
                    <small>
                      <p>Four interest-free payments. No fees or credit check.</p>
                      <ul className="list-unstyled u-padding-L-xs" style={{borderLeft: 'solid 5px #e5e5e5'}}>
                        {formattedInstallmentsDates.map((date, index) => (
                          <li key={index}>
                            Due <strong>{date}</strong> {formatPrice(utils.calculateInstallmentsPrice(totalExcludingTax))}
                          </li>
                        ))}
                      </ul>
                    </small>
                  </div>
                )
              }
            ]}
            value={billingCycle}
            onChangeCondition={onChange}
          />
        </div>
      </fieldset>
    </div>
  );
};

export default InstallmentsFormGroup;
